export default "__VITE_ASSET__cedd1cbd__"